// eslint-disable-next-line no-unused-vars
import { gsap } from 'gsap';

class DropdownMenu {

    doAThing() {
        console.log('Do a thing')
    }

    constructor() {

      //let mobile = true;
        let menuOpen = false;
        var menuWrapper = '.menu-wrapper';
        var menuToggle = '#show-menu';
     // var subMenu = '.sub-menu';

        let dropDownOpen = false;
      // eslint-disable-next-line no-unused-vars
        let navHeight = '';

        function getHeight()
        {

            console.log('getHeight')
            navHeight = $('.dropdown-menu-style').height();

            console.log('navHeight', navHeight)
        }


        if ($('.dropdown-menu-style').length) {
            console.log('Is dropdown')

            gsap.delayedCall(1, getHeight)

            $('.nav-primary-dropdown .menu-item-has-children > a').click(function (e) {

                e.stopPropagation();

                e.preventDefault ? e.preventDefault() : (e.returnValue = false);

               // e.preventDefault();

                console.log('nav-primary .menu-item-has-children');

                e.stopPropagation();

                var $link = $(this);

                function showDropdown()
                {

                    var $sub = $link.siblings('.sub-menu');

                    gsap.set('.sub-menu',{opacity:0, display:'none'})
                    gsap.set($sub,{opacity:0, display:'block'})

                    //let subHeight = $sub.height();
                    //let myMarginTop = parseInt($sub.css('marginTop'));
                    //let newHeight = subHeight + navHeight + myMarginTop

                    //gsap.to('.dropdown-menu-style', {height: newHeight, duration:0.25})
                    gsap.to($sub, {opacity:1, duration:0.25})

                }

                if ($(this).parent().parent().parent().hasClass('nav-primary-dropdown')) {
                    console.log('child of nav');

                    e.preventDefault();

                    if (!$link.siblings('.sub-menu').hasClass('visible')) {
                        $('.nav-primary-dropdown .menu-item-has-children a').removeClass('sub-open');
                        $link.addClass('sub-open');
                        $('.sub-menu').removeClass('visible');
                        dropDownOpen = true;

                        showDropdown();
                    } else {
                        dropDownOpen = false;
                        $('.sub-menu').removeClass('visible');
                        $link.removeClass('sub-open');
                    }
                }
            });
        }

        $('html').click(function () {
            if (dropDownOpen === true) {
                $('.nav-primary-dropdown .menu-item-has-children a').removeClass('sub-open');

                gsap.to('.dropdown-menu-style', {height: navHeight})
                gsap.set('.sub-menu',{opacity:0, display:'none'})

                dropDownOpen = false;
            }

        });



      $(menuToggle).click(function () {

        console.log('-------- main-navbar click');

        if (menuOpen) {
            console.log('close');

            $(menuToggle).removeClass('open');

            hideMenu();
          //$('.nav-primary').removeClass('menu-open');

          //TweenMax.set('.main-navbar .navbar-toggle .open-menu', {css:{display:'block'}});
          //TweenMax.set('.main-navbar .navbar-toggle .close-menu', {css:{display:'none'}});
         // gsap.to(menuWrapper,  {right:'-100%', duration:0.5, onComplete: hideMenu});
        } else {
            console.log('open');

          //$(menuToggle).addClass('open');
            $(menuWrapper).addClass('menu-open');

          //gsap.to(menuWrapper, {right:'0%', duration:0.5});
        }

        menuOpen =! menuOpen;

      });

    function hideMenu()
    {

        $(menuWrapper).removeClass('menu-open');

    }
    }
}

export default DropdownMenu



// WEBPACK FOOTER //
// ./scripts/util/dropdownMenu.js